<template>
  <div class="content">
    <p v-html="$gettext('You have reached the maximum number of clients under your plan.')" />
    <div class="feature-list">
      <p class="feature-list__title">{{ $gettext('Please adjust your subsubscription.') }}</p>
      <ul>
        <li class="list-item">
          <div class="list-item__icon"><font-awesome-icon icon="fa-regular fa-circle-check" /></div>
          <div class="list-item__text">
            <p><span v-html="$gettext('Prices per connected user as low as 80 cents per month.')" /></p>
          </div>
        </li>
        <li class="list-item">
          <div class="list-item__icon"><font-awesome-icon icon="fa-regular fa-circle-check" /></div>
          <div class="list-item__text">
            <p><span v-html="$gettext('All connected clients get an account in your brand identity.')" /></p>
          </div>
        </li>
        <li class="list-item">
          <div class="list-item__icon"><font-awesome-icon icon="fa-regular fa-circle-check" /></div>
          <div class="list-item__text">
            <p><span v-html="$gettext('Connected clients get a discount to upgrade to Premium.')" /></p>
          </div>
        </li>
        <li class="list-item">
          <div class="list-item__icon"><font-awesome-icon icon="fa-regular fa-circle-check" /></div>
          <div class="list-item__text">
            <p><span v-html="$gettext('You get a kickback fee every time someone uses your discount.')" /></p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PremiumModalDefaultContentAccountants",
  }
</script>

<style lang="scss" scoped>

</style>